import { useMutation, UseMutationResult } from "@tanstack/react-query";
import getTranslations from "shared/api/openai/getTranslations";
import handleGameNameTranslations from "shared/api/openai/handleGameNameTranslations";
import {
  TranslationError,
  TranslationSuccess,
  TranslationRequestData,
} from "shared/api/openai/types";

export const useAutoTranslateMutation = (): UseMutationResult<
  TranslationSuccess,
  TranslationError,
  TranslationRequestData
> => {
  return useMutation<
    TranslationSuccess,
    TranslationError,
    TranslationRequestData
  >({
    mutationFn: async (
      data: TranslationRequestData,
    ): Promise<TranslationSuccess> => {
      const response = await getTranslations(data);
      if ("errorMessage" in response) {
        throw response;
      }
      return response as TranslationSuccess;
    },
  });
};

export const useAutoTranslateGameNameMutation = (): UseMutationResult<
  TranslationSuccess,
  TranslationError,
  TranslationRequestData
> => {
  return useMutation<
    TranslationSuccess,
    TranslationError,
    TranslationRequestData
  >({
    mutationFn: async (
      data: TranslationRequestData,
    ): Promise<TranslationSuccess> => {
      const response = await handleGameNameTranslations(data);
      if ("errorMessage" in response) {
        throw response;
      }
      return response as TranslationSuccess;
    },
  });
};
